/**
 * Full-site maintenance screen — shown when site maintenance mode is on.
 */

import { Link } from 'react-router-dom';

import { MaintenanceTrafficConeIcon } from '@components/features/maintenance';
import { Logo } from '@components/Logo';

import { resolveMaintenanceMessage } from '@lambda/shared/maintenanceDefaults';

import './MaintenancePage.css';

export interface MaintenancePageProps {
  message?: string;
  supportEmail?: string;
}

export function MaintenancePage({ message, supportEmail }: MaintenancePageProps) {
  const body = resolveMaintenanceMessage(message);
  const email = supportEmail?.trim();

  return (
    <div className="bhg-maintenance">
      <div className="bhg-maintenance__card">
        <div className="bhg-maintenance__logo" aria-hidden>
          <Logo size="medium" showText />
        </div>
        <div className="bhg-maintenance__icon" aria-hidden>
          <MaintenanceTrafficConeIcon size="xl" className="bhg-traffic-cone-icon--hero" />
        </div>
        <h1 className="bhg-maintenance__title">Our site is under maintenance</h1>
        <p className="bhg-maintenance__message">{body}</p>
        {email ? (
          <p className="bhg-maintenance__contact">
            If you have an urgent matter, contact us at{' '}
            <a href={`mailto:${email}`} className="bhg-maintenance__email">
              {email}
            </a>
            .
          </p>
        ) : null}
        <p className="bhg-maintenance__admin-login">
          <Link to="/login" className="bhg-maintenance__login-link">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
